var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { AddOperation, DeltaUpdateOperation, SchemaObject, SignalOperation, UpdateOperation } from '@augloop/types-core';
import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
var supportedOperationSet = new Set([
    AddOperation.getTypeName(),
    UpdateOperation.getTypeName(),
    SignalOperation.getTypeName(),
    DeltaUpdateOperation.getTypeName()
]);
var percentageOfApplyContextIdOnOperationsLogs = 0.5;
var ContextIdManager = /** @class */ (function () {
    function ContextIdManager() {
        this.collectionScopeTypesOnJoinWorkflows = new Set();
        this.updatesByScopeItemPath = new Map();
    }
    ContextIdManager.prototype.setActiveScopeType = function (collectionScopeType) {
        this.collectionScopeTypesOnJoinWorkflows.add(collectionScopeType);
    };
    ContextIdManager.prototype.applyContextIdOnOperations = function (ops) {
        var e_1, _a, e_2, _b, e_3, _c;
        try {
            for (var ops_1 = __values(ops), ops_1_1 = ops_1.next(); !ops_1_1.done; ops_1_1 = ops_1.next()) {
                var op = ops_1_1.value;
                var opType = SchemaObject.getTypeNameFor(op);
                if (!this.isSupportedOperation(opType)) {
                    continue;
                }
                try {
                    for (var _d = (e_2 = void 0, __values(op.items)), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var item = _e.value;
                        var logOp = undefined;
                        if (Math.random() * 100 <= percentageOfApplyContextIdOnOperationsLogs) {
                            logOp = new LogOperation({ operationName: 'ApplyContextIdOnOperations', success: true }).start();
                        }
                        // If the item already has a contextId keep it because it was
                        // piped from previous items
                        if (item.contextId) {
                            this.tryLogMessage(logOp, "Item of id: " + item.id + " already has a contextId " + item.contextId);
                        }
                        else {
                            var copyItemWithPath = __assign({ parentPath: op.parentPath }, item);
                            if (opType === DeltaUpdateOperation.getTypeName()) {
                                // TextTileDelta have id equal to the related TextTile, and the parentPath includes the TextTile id.
                                var tileCopyItemWithPath = __assign(__assign({}, item), { parentPath: op.parentPath.slice(0, -1) });
                                // Here we create a new contextId if we a TextTile related to this Delta.
                                if (this.updatesByScopeItemPath.has(this.makeItemPathStr(tileCopyItemWithPath))) {
                                    item.contextId = this.getNewContextId(tileCopyItemWithPath);
                                    this.tryLogMessage(logOp, "DeltaUpdateOperation " + item.id + " already has a related TextTile, its new contextId is " + item.contextId);
                                }
                                else {
                                    this.tryLogMessage(logOp, "DeltaUpdateOperation " + item.id + " don't have a related TextTile with contextId");
                                }
                                continue;
                            }
                            // Check if this item can be a scope item of any active join workflow
                            if (this.isScopeTypeOfAnyJoinWorkflow(item.body)) {
                                item.contextId = this.getNewContextId(copyItemWithPath);
                                this.tryLogMessage(logOp, "Item of id: " + item.id + " is scope item of a join and its contextId is " + item.contextId);
                            }
                            else {
                                // The item can be under a scope item that already has ContextId, so we must
                                // pipe it from the parent scope item that has the contextId
                                var itemPath = this.makeItemPathStr(copyItemWithPath);
                                try {
                                    for (var _f = (e_3 = void 0, __values(this.updatesByScopeItemPath.keys())), _g = _f.next(); !_g.done; _g = _f.next()) {
                                        var scopeItemPath = _g.value;
                                        if (itemPath.indexOf(scopeItemPath) >= 0) {
                                            item.contextId = this.getContextId(scopeItemPath);
                                            this.tryLogMessage(logOp, "Item of id: " + item.id + " is not scope item of a join and its contextId is " + item.contextId);
                                        }
                                    }
                                }
                                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                finally {
                                    try {
                                        if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                                    }
                                    finally { if (e_3) throw e_3.error; }
                                }
                                if (!item.contextId) {
                                    this.tryLogMessage(logOp, "Item of id: " + item.id + " does not belong to any join workflow execution");
                                }
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (ops_1_1 && !ops_1_1.done && (_a = ops_1.return)) _a.call(ops_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    ContextIdManager.prototype.getNewContextId = function (scopeItem) {
        var scopeItemPath = this.makeItemPathStr(scopeItem);
        var oldUpdateCount = this.updatesByScopeItemPath.get(scopeItemPath) || 0;
        this.updatesByScopeItemPath.set(scopeItemPath, oldUpdateCount + 1);
        return this.getContextId(scopeItemPath);
    };
    ContextIdManager.prototype.isSupportedOperation = function (operationType) {
        return supportedOperationSet.has(operationType);
    };
    ContextIdManager.prototype.isScopeTypeOfAnyJoinWorkflow = function (obj) {
        var scopeTypesOfJoins = __spreadArray([], __read(this.collectionScopeTypesOnJoinWorkflows), false);
        return scopeTypesOfJoins.length === 0 ? false : SchemaObject.matchesTypesFor(obj, scopeTypesOfJoins);
    };
    ContextIdManager.prototype.makeItemPathStr = function (item) {
        return __spreadArray(__spreadArray([], __read(item.parentPath), false), [item.id], false).join('/');
    };
    ContextIdManager.prototype.getContextId = function (scopeItemPath) {
        return scopeItemPath + '@' + this.updatesByScopeItemPath.get(scopeItemPath);
    };
    ContextIdManager.prototype.tryLogMessage = function (logOp, message) {
        if (logOp) {
            logOp.resultDescription = message;
            Log.verbose(0x1f6e1759 /* tag_5173z */, LogCategory.CoreDefault, logOp.stop());
        }
    };
    return ContextIdManager;
}());
export { ContextIdManager };
//# sourceMappingURL=context-id-manager.js.map